<template>
    <i v-if="fontAwesomeClass" :class="fontAwesomeClass"/>
    <i v-else :data-feather="name"/>
</template>

<script>
import CoreLibrary from "../../helpers/CoreLibrary";

export default {
    name: "AppIcon",
    extends: CoreLibrary,
    props: {
        name: {
            default: '',
            type: String,
        },
        iconClass: {
            default: '',
            type: String,
        }
    },
    computed: {
        fontAwesomeClass() {
            if (!this.name) {
                return null;
            }
            
            // Trim whitespace
            const iconName = this.name.trim();
            
            // If the name already looks like a Font Awesome class (contains 'fa-'), use it directly
            if (iconName.includes('fa-')) {
                // Check if it already has a proper prefix (fas, far, fab, etc.)
                if (iconName.match(/^(fas|far|fal|fab|fad|fak)\s+fa-/i)) {
                    return iconName;
                } else if (iconName.startsWith('fa-')) {
                    // If it starts with fa- but no prefix, add fas
                    return 'fas ' + iconName;
                } else if (iconName.match(/fa-[a-z0-9-]+/i)) {
                    // If it contains a Font Awesome icon class pattern, use as is
                    return iconName;
                }
            }
            
            // First check if icon is already defined in getIcons()
            const definedIcon = this.getIcons().find(item => {
                return item.name === iconName;
            });
            if (definedIcon && definedIcon.iconType === 'fontawesome') {
                return definedIcon.iconName;
            }
            
            // Map feather icon names to Font Awesome classes
            const iconMap = {
                'pie-chart': 'fas fa-chart-pie',
                'users': 'fas fa-users',
                'list': 'fas fa-list',
                'plus': 'fas fa-plus',
                'user-check': 'fas fa-user-check',
                'user-plus': 'fas fa-user-plus',
                'grid': 'fas fa-th',
                'settings': 'fas fa-cog',
                'file-text': 'fas fa-file-alt',
                'headphones': 'fas fa-headphones',
                'package': 'fas fa-box',
                'paperclip': 'fas fa-paperclip',
                'map-pin': 'fas fa-map-marker-alt',
                'flag': 'fas fa-flag',
                'activity': 'fas fa-chart-line',
                'gift': 'fas fa-gift',
                'user': 'fas fa-user',
                'image': 'fas fa-image',
                'shopping-cart': 'fas fa-shopping-cart',
                'credit-card': 'fas fa-credit-card',
                'home': 'fas fa-home',
                'video': 'fas fa-video',
                'user-video': 'fas fa-user-video',
                'cloud': 'fas fa-cloud',
                'bar-chart': 'fas fa-chart-bar',
            };
            
            return iconMap[iconName] || null;
        }
    },
    methods: {
        getIcons() {
            return [
                {
                    name: 'sort',
                    iconType: 'fontawesome',
                    iconName: 'fas fa-sort',
                },
                {
                    name: 'pinterest',
                    iconType: 'fontawesome',
                    iconName: 'fab fa-pinterest-p',
                },
                {
                    name: 'dribble',
                    iconType: 'fontawesome',
                    iconName: 'fab fa-dribbble',
                },
                {
                    name: 'behance',
                    iconType: 'fontawesome',
                    iconName: 'fab fa-behance',
                },
                {
                    name: 'google-plus',
                    iconType: 'fontawesome',
                    iconName: 'fab fa-google-plus-g',
                },
                {
                    name: 'skype',
                    iconType: 'fontawesome',
                    iconName: 'fab fa-skype',
                },
                {
                    name: 'paint-brush',
                    iconType: 'fontawesome',
                    iconName: 'fas fa-paint-brush',
                },
                {
                    name: 'palette',
                    iconType: 'fontawesome',
                    iconName: 'fas fa-palette',
                }
            ]
        }
    }
}
</script>
